import { useConfig } from '@/composables/config'
import { getUACFromCookies30d } from '@/utils/cookie-parser'
import safeURLParse from '@/utils/safeURLParse'
import { getUACCampaignId } from '@/utils/uac-cookie'

export const CREATIVE_IDS = {
    FOOTER: 'footer',
    UNDER_GAME_ICON: 'under_game_icon',
    GAME_DESCRIPTION: 'game_description',
    PLAY_ON_APP_PROMO_BANNER: 'play_on_app_promo_banner',
    ANDROID_SMART_BANNER: 'android_smart_banner',
    GET_THE_APP_QR: 'get_the_app_qr',
}

export function useGoToApp(creativeId: string) {
    const { VUE_APP_NATIVE_APP_ADJUST_URL } = useConfig()

    function goToApp() {
        const rawUrl = VUE_APP_NATIVE_APP_ADJUST_URL.replace('%PATH%', window.location.pathname)
        const url = safeURLParse(rawUrl)
        if (!url) {
            window.open(rawUrl, '_blank')
            return
        }

        url.searchParams.set('adj_creative', creativeId)

        const campaignId = getUACCampaignId(getUACFromCookies30d(document.cookie))
        if (campaignId) {
            url.searchParams.set('adj_campaign', campaignId)
        }

        window.open(url.toString(), '_blank')
    }

    return { goToApp }
}
